export default {
  booking: {
    default: 'Réservation | Réservations',
    view: 'Consulter la réservation',
    list: {
      'arrival_date': 'Date d\'arrivée',
      'departure_date': 'Date de départ',
      page_title: 'Liste des réservations'
    },
    status: {
      '-1': {
        default: 'Réservation désactivée'
      },
      0: {
        default: 'Réservation inachevée',
        alt: 'Créée'
      },
      4: {
        default: 'Brouillon'
      },
      5: {
        default: 'Réservation inachevée',
        alt: 'Brouillon'
      },
      10: {
        default: "En attente d'autorisation",
        manager: 'Demande à autoriser'
      },
      20: {
        default: 'Demande envoyée'
      },
      30: {
        default: 'Refusée'
      },
      40: {
        default: 'En cours de traitement'
      },
      45: {
        default: 'En attente de validation',
        manager: 'Proposition à valider'
      },
      50: {
        default: 'En attente de confirmation'
      },
      55: {
        default: "En attente du bon de commande"
      },
      60: {
        default: 'Confirmée'
      },
      65: {
        default: 'Modification envoyée'
      },
      70: {
        default: 'Annulation demandée'
      },
      80: {
        default: 'Annulée'
      },
      90: {
        default: 'Réservation terminée'
      }
    },
    array: {
      type: 'Réservation',
      per_type:'Par type',
      travellers: 'Voyageurs',
      destination: 'Destination',
      dates: 'Dates',
      per_date: 'Par date',
      status: 'Statut',
      city_selected_s: "ville sélectionnée | villes sélectionnées",
      hotel_selected_s: "hôtel sélectionné | hôtels sélectionnés",
      status_selected_s: "statut sélectionné | statuts sélectionnés",
      ref_selected_s: "référence sélectionnée | références sélectionnées",
      traveller_selected_s: "voyageur sélectionné | voyageurs sélectionnés",
      per_status: 'Par statut',
      per_hotel:'Par hôtel',
      deadline: "Date limite annulation / confirmation sans frais",
      confirmation_deadline: 'Date limite de confirmation',
      cancellation_deadline: 'Date limite d\'annulation sans frais',
      who_booked: 'Réservataire',
      actions: 'Actions',
      select_bookingRef: "Saisir ou sélectionner une référence de réservation",
      select_status: 'Saisir ou sélectionner un ou des statuts',
      select_hotel: 'Saisir ou sélectionner un ou des hôtels',
      select_city: "Saisir ou sélectionner une ou des villes",
      select_traveller: "Saisir ou sélectionner un ou des voyageurs",
      select_ref: "Saisir ou sélectionner une ou des références de société",
      select_orderNumber: "Saisir ou sélectionner un ou des bons de commande",
      ref: "Référence"
    },
    filters: {
      title: {
        bookingRef: "Référence de réservation",
        type: "Type",
        dates: "Dates",
        destination: "Destination",
        city: "Ville",
        hotel: "Hôtel",
        traveller: "Voyageur",
        status: "Statut",
        ref: "Référence de société",
        orderNumber: "Bon de commande"
      }
    },
    legend: {
      title: 'Légende',
      show: 'voir la fiche',
      duplicate: 'dupliquer la réservation',
      edit: 'modifier la réservation',
      cancel: 'annuler la réservation',
      download: 'télécharger le voucher',
      allow: 'autoriser',
      deny: 'refuser',
      validate: 'valider',
      review:'voir'
    },
    allow: {
      question: 'Souhaitez-vous vraiment autoriser cette demande ?',
      validation: 'La demande a été autorisée avec succès'
    },
    allow_booking: {
      question: "Souhtaitez-vous vraiment autoriser cette réservation ?",
      validation: "La réservation a été validée avec succès"
    },
    validate: {
      question: "Souhaitez-vous vraiment valider cette proposition ?",
      validation: "La proposition a été validée avec succès"
    },
    confirm: {
      question1: "En acceptant cette réservation, vous confirmez avoir bien pris connaissance des conditions de modifications et d’annulations et que tout changement éventuel devra s’effectuer par vos soins directement sur la plateforme BBA.",
      question2: "Voulez-vous confirmer ?",
      validation: 'La réservation a été confirmée avec succès',
      validationButOrderNumber: "Votre confirmation a été prise en compte. Cependant, vous devez saisir le numéro de bon de commande afin qu'elle soit totalement effective.",
      page: {
        intro: ''
      }
    },
    cancel: {
      question: 'Souhaitez-vous vraiment annuler votre réservation ?',
      placeholder: 'Veuillez en indiquer la raison',
      success: "Votre demande d'annulation a été prise en compte",
      success_online: "La réservation a été annulée",
      error: "Veuillez sélectionner une raison d'annulation"
    },
    deny: {
      prevalidation: {
        question: 'Souhaitez-vous vraiment refuser cette demande ?',
        validation: 'La demande a bien été refusée'
      },
      postvalidation: {
        question: 'Souhaitez-vous vraiment refuser cette proposition ?',
        validation: 'La proposition a bien été refusée'
      },
      placeholder: 'Veuillez en indiquer la raison'
    },
    send_voucher: {
      title: "Transférer l'email de confirmation",
      label: "Email",
      placeholder: "Pour saisir plusieurs adresses, les séparer par \";\"",
      success: "Le voucher a été envoyé à {email}.",
      error: "Une erreur est survenue. Veuillez contacter votre agent de réservation.",
      no_email: "Veuillez saisir une adresse email"
    },
    notify_travellers: {
      success: "L'email de confirmation a été envoyé aux voyageurs"
    },
    orderNumber: {
      title: "Saisir le bon de commande",
      addPdf: "Joindre un PDF (max 2 Mo)",
      success: "Votre réservation est désormais finalisée, vous allez recevoir par email votre voucher. Vous pouvez également le télécharger en affichant le détail de cette réservation",
      error: "Une erreur est survenue. Veuillez contacter votre agent de réservation.",
      noValue: "Veuillez saisir une valeur",
      wrongValue: "Veuillez saisir une valeur en lien avec le motif de votre bon de commande"
    },
    room: {
      single: 'Occupation par 1 personne',
      double: 'Occupation par 2 personnes'
    },
    archived_bookings:'Réservations archivées',
    bookings_in_progress: 'Réservations en cours',
    requests_submitted: 'Réservations en cours',
    requests_sent: 'Réservations archivées',
    new: 'Nouvelle Réservation',
    cancel_with_charges: 'Annulable avec frais',
    download_pdf: "Télécharger le voucher",
    download_ics: "Télécharger l'ICS",
    download_order_pdf: "Télécharger le bon de commande",
    download_list: "Télécharger la liste des réservations",
    my_booking: 'Ma réservation',
    no_offer_this_date: 'Aucune offre à cette date',
    contactBBA: 'contacter BBA',
    your_opinion: 'votre avis',
    meal_contribution: 'Prise en charge du repas à hauteur de',
    maxPricePerRoom: "Prix maximum autorisé par chambre",
    summary: {
      title: 'Récapitulatif de votre réservation',
      title_confirmed_reservation: 'Réservation confirmée',
      night_s: 'nuitée | nuitées',
      room_s: 'chambre | chambres',
      place: 'Lieu',
      traveller_s: 'voyageur | voyageurs',
      per_night: 'par jour',
      btn_confirm: 'Confirmer la réservation',
      btn_confirm_and_pay: 'Confirmer',
      onsite: 'règlement sur place',
      handled: 'prise en charge',
      comment: 'Commentaires',
      refs: 'Références de réservation',
      paymentCB: {
        message: {
          ALWAYS: 'Vous devez saisir vos données de carte bancaire comme garantie',
          CHARGEABLE_CANCELLATION: 'Vous avez sélectionné un tarif en « annulation payante ». La carte bancaire fournie habituellement par BBA en garantie va être automatiquement débitée par l’hôtel et vous ne pourriez plus régler directement sur place à la fin du séjour comme votre société le prévoit. C’est pourquoi nous vous demandons de saisir votre propre carte bancaire qui sera cryptée et transmise à l’hôtel.\n'
        }
      }
    },
    modify: {
      impossible: 'Vous ne pouvez pas éditer cette réservation.'
    },
    select: {
      default: 'Sélectionnez une action',
      show: 'Voir',
      duplicate: 'Dupliquer',
      edit: 'Modifier',
      edit_draft: 'Finaliser la réservation',
      cancel: 'Annuler',
      contactBBA: 'Contacter BBA',
      download_ics: 'Télécharger l\'ICS',
      download_pdf: 'Télécharger le voucher',
      download_order_pdf: "Télécharger le bon de commande",
      allow: 'Autoriser',
      deny: 'Refuser',
      validate: 'Valider',
      online_validate: 'Terminer la réservation',
      send_voucher: "Transférer le voucher",
      confirm: "Confirmer"
    },
    notFoundMessage: {
      todo: 'Aucune réservation à traiter',
      in_progress: 'Aucune réservation en cours',
      history: 'Aucun historique de réservations'
    },
    show: {
      title: {
        actions_history: 'Historique des actions',
        destination: 'Destination',
        dates: 'Dates',
        rooms: 'Chambres / Voyageurs',
        requests: 'Services',
        comments: 'Commentaires',
        summary: 'Résumé',
        conditions: 'Conditions',
        prices: 'Tarifs',
        refs: 'Références de réservation',
        hotel_ref: "Réservation Hôtel n°"
      },
      main_infos: {
        status: 'Statut de la demande',
        booking_number: 'Numéro de réservation',
        cancellation_deadline: 'Date limite d\'annulation',
        confirmation_deadline: 'Date limite de confirmation',
        is_online: 'Demande Online',
        is_offline: 'Demande Offline',
        is_contingent: 'Allotement',
        company_contact: 'Contact société',
        bba_contact: 'Demande traitée par',
        booking_date: 'Date de la demande'
      },
      destination: {
        wish: 'Destination souhaitée',
        favorite: {
          location: 'Lieu favori',
          hotel: 'Hôtel favori'
        }
      },
      rooms: {
        single: 'Occupation par 1 personne | Occupation par 1 personne',
        double: 'Occupation par 2 personnes | Occupation par 2 personnes'
      },
      search_priority: {
        tooltip: 'Il s\'agit du critère de priorité (budget ou lieu) que vous avez précisé et qui s\'applique en cas de difficultés de réservation avec les critères exacts de votre demande de réservation'
      },
      page_title: 'Fiche Réservation',
      prices: {
        total_price: "Prix total de la réservation : ",
        breakfast: {
          included: "Petit-déjeuner inclus",
          excluded: {
            noValue: "Petit-déjeuner en supplément",
            inc: "Dont petit-déjeuner à {price} @:_perPersonPerDay"
          }
        },
        residence_tax: "Dont taxe de séjour à {price} @:_perPersonPerDay",
        is_etape: "Repas du soir inclus (demi-pension)",
        variable_tax: 'Dont taxe variable à',
        feesGlobal: "Dont {label} à {price}",
        feesPerRoom: "Dont {label} à {price} @:_perRoom",
        reminder: "(*)  Pour les séjours hors zone euro, ce tarif est le résultat de la conversion au taux du jour avec la devise du pays concerné, ce tarif sera mis à jour en fonction du taux appliqué par la banque au moment du paiement."
      },
      conditions: {
        cancellation: 'Conditions d\'annulation',
        payment_method: 'Mode de paiement',
        payment_detail: "Détails de paiement"
      },
      hrsDetails: {
        title: "Détails HRS"
      }
    },
    managersValidation: {
      title: "Affectation des managers",
      text: "Cette réservation sera soumise à validation par un manager. Veuillez sélectionner le(s) manager(s) à notifier pour poursuivre votre réservation.",
      placeholder: "Sélectionnez un ou plusieurs managers",
      error: "Vous devez sélectionner au moins un manager",
      errorLabel: "Manager(s)",
      summaryItemTitle: "@:booking.managersValidation.showItemTitle",
      showItemTitle: "Valideur | Valideurs"
    },
    requestConfirm: {
      title: {
        default: "Réservation effectuée"
      },
      confirm: "Votre confirmation a été prise en compte.",
      done: "Votre réservation a bien été effectuée.",
      orderNumber: {
        main: "ATTENTION : pour obtenir votre voucher, vous devez mettre à jour les références de votre {label}",
        btns: "soit en cliquant sur \"Consulter la réservation\", soit en retournant sur la page \"Mes réservations\""
      }
    }
  }
}
